<script setup>
import { FileText, FileImage } from 'lucide-vue-next'
import Card from './Card.vue'
import DownloadLink from './DownloadLink.vue'

defineProps({
  documents: { type: Array, required: true },
})

// Fotos ganham ícone de imagem; o resto, documento.
const iconFor = (name) => (/foto/i.test(name) ? FileImage : FileText)
</script>

<template>
  <Card title="Documentos recentes" :icon="FileText" link-label="Ver todos" link-href="/documentos">
    <p v-if="!documents.length" class="py-6 text-center text-sm text-slate-500">
      Nenhum documento disponível ainda.
    </p>

    <ul v-else class="divide-y divide-slate-100">
      <li v-for="doc in documents" :key="doc.name" class="flex items-center gap-3 py-3.5">
        <component :is="iconFor(doc.name)" class="h-5 w-5 shrink-0 text-up-navy" aria-hidden="true" />
        <div class="min-w-0">
          <p class="truncate font-medium text-up-navy">{{ doc.name }}</p>
          <p class="text-xs text-slate-500">Atualizado em {{ doc.updated_at }}</p>
        </div>
        <DownloadLink :id="doc.id" :name="doc.name" :available="doc.downloadable" />
      </li>
    </ul>
  </Card>
</template>
